import { __awaiter } from "tslib";
export function loadInputMask() {
    return __awaiter(this, void 0, void 0, function* () {
        const { InputMask } = yield import('./InputMask');
        return InputMask;
    });
}

//# sourceMappingURL=loadInputMask.js.map
